import { Checkbox, Input } from 'antd';

const CustomCheckbox = ({
  Form,
  rules,
  data,
  parentKey,
  renderCheckbox,
  otherOption,
  handleOtherOption,
  handleTracking
}) => {
  return (
    <>
      <Form.Item
        name={[parentKey, data.name]}
        label={data.title}
        rules={rules?.[data?.name]}
        valuePropName="checked"
        onBlur={data.onBlurTrack ? handleTracking : () => {}} 
      >
        <Checkbox name={data.name} >{ data.options.label }</Checkbox>
      </Form.Item>
    </>
  );
};

export default CustomCheckbox;
